<template>
  <div>
    <Card
      style="margin-top: 20px"
      :style="{
        backgroundImage: `url(${getWaterMarkStatus})`
      }"
    >
      <Table
        border
        stripe
        ref="table"
        :loading="loading"
        :columns="columns"
        :data="data"
        highlight-row
        @on-row-click="rowClick"
      >
      </Table>
    </Card>
    <Card
      style="margin-top: 20px"
      :style="{
        backgroundImage: `url(${getWaterMarkStatus})`
      }"
    >
      <p slot="title">社会关系信息</p>
      <Form
        style="margin: 30px 20px"
        :model="formItem"
        inline
        :label-width="150"
        label-position="left"
        :disabled="disableSelfData.SocialRelationship == 0"
      >
        <FormItem
          :label="lang == 'zh' ? chNameMap[val] : enNameMap[val]"
          v-for="(val, key) in sortfMap"
          :key="val"
          v-if="showSelfData[val] == '1'"
        >
          <Checkbox
            v-if="val == 'emergencycontact'"
            v-model="formItem[val]"
            :disabled="disableSelfData[val] == 0"
          ></Checkbox>
          <DatePicker
            v-else-if="val == 'birthday'"
            type="date"
            v-model="formItem[val]"
            style="min-width: 260px;margin-right: 50px;"
            :disabled="disableSelfData[val] == 0"
          ></DatePicker>
          <Input
            v-else
            v-model="formItem[val]"
            style="min-width: 260px;margin-right: 50px;"
            :disabled="disableSelfData[val] == 0"
          />
        </FormItem>
      </Form>
    </Card>
    <div class="bottomBtn">
      <Button
        type="primary"
        @click="saveData()"
        :disabled="disableSelfData.SocialRelationship == 0"
        >保存</Button
      >
      <Button v-if="plan" @click="returnPage()" style="margin-left: 15px"
        >返回</Button
      >
    </div>
  </div>
</template>

<script>
import axios from "axios";
import DateUtil from "../../../../../src/util/DateUtil";
import watermark from "@/util/watermark";

export default {
  data() {
    return {
      date: new DateUtil(),
      formItem: {},
      emp_code: {},
      data: [],
      pageInfo: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 10
      },
      total: 1,
      loading: false,
      emergencycontact: null,
      disableSelfData: {},
      showSelfData: {},
      chNameMap: {},
      enNameMap: {},
      id: null,
      plan: null,
      userId: "",
      sortfMap: {}
    };
  },
  created() {
    let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    this.userId = userInfo.serialnumber;
  },
  computed: {
    //国际化监听
    lang() {
      return this.$store.getters.selectLangeData;
    },
    getWaterMarkStatus() {
      return this.$store.getters.getWaterMarkStatus == 1
        ? watermark.addWaterMark()
        : "";
    },
    columns() {
      let column = [
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.emergencycontact
              : this.enNameMap.emergencycontact,
          key: "emergencycontact",
          align: "center",
          minWidth: 180,
          render: (h, params) => {
            let emergencycontact1 = params.row.emergencycontact;
            if (emergencycontact1 == 1) {
              emergencycontact1 = "是";
            } else {
              emergencycontact1 = "否";
            }
            return h("span", emergencycontact1);
          }
        },
        {
          title: this.lang == "zh" ? this.chNameMap.name : this.enNameMap.name,
          key: "name",
          align: "center",
          minWidth: 180
        },
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.relation
              : this.enNameMap.relation,
          key: "relation",
          align: "center",
          minWidth: 180
        },
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.companyname
              : this.enNameMap.companyname,
          key: "companyname",
          align: "center",
          minWidth: 180
        },
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.businessphone
              : this.enNameMap.businessphone,
          key: "businessphone",
          align: "center",
          minWidth: 180
        },
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.homephone
              : this.enNameMap.homephone,
          key: "homephone",
          align: "center",
          minWidth: 180
        },
        {
          title:
            this.lang == "zh" ? this.chNameMap.mobile : this.enNameMap.mobile,
          key: "mobile",
          align: "center",
          minWidth: 180
        },
        {
          title:
            this.lang == "zh" ? this.chNameMap.pager : this.enNameMap.pager,
          key: "pager",
          align: "center",
          minWidth: 180
        },
        {
          title: this.lang == "zh" ? this.chNameMap.city : this.enNameMap.city,
          key: "city",
          align: "center",
          minWidth: 180
        }
      ];
      let arr = [];
      arr = column.filter(item => {
        return this.showSelfData[item.key] == 1;
      });
      return arr;
    }
  },
  methods: {
    getData(id, plan) {
      this.plan = plan ? plan : "";
      this.id = id;
      this.getTableData();
    },
    getTableData() {
      let obj = {
        sheetId: this.id,
        serialnumber: this.plan ? this.plan : this.userId,
        bePersonal: this.plan ? "0" : "1",
        pageNo: this.pageInfo.pageNo,
        pageSize: this.pageInfo.pageSize
      };
      this.loading = true;
      axios
        .post("/SocialRelations/searchUserSocialRelations", obj)
        .then(res => {
          this.loading = false;
          if (res) {
            this.data = res.data;
            this.total = Number(res.pageInfo.total);
            this.showSelfData = res.showSelfData;
            delete this.showSelfData.SocialRelationship;
            this.disableSelfData = res.disableSelfData;
            this.sortfMap = res.sortfMap;
            this.chNameMap = res.chNameMap;
            this.enNameMap = res.enNameMap;
          }
        });
    },
    pageChange(val) {
      this.pageInfo.pageNo = val;
      this.getTableData();
    },
    rowClick(row, index) {
      this.formItem = row;
      this.formItem.emergencycontact = !!+this.formItem.emergencycontact;
    },
    saveData() {
      this.$Modal.confirm({
        title: this.$notice("sureSave"),
        content: "",
        onOk: () => {
          let obj = {
            serialnumber: this.plan,
            ...this.formItem,
            emergencycontact: (this.emergencycontact =
              this.formItem.emergencycontact == true ? 1 : 0)
          };
          axios
            .post("/SocialRelations/rollBackUserSocialRelations", obj)
            .then(res => {
              if (res) {
                this.getTableData();
                this.$Message.info(res);
                this.formItem = {};
              }
            });
        },
        onCancel: () => {}
      });
    },
    returnPage() {
      this.$router.back();
    }
  }
};
</script>

<style scoped>
.formRow {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.formCol {
  width: calc(100% / 3);
  display: inline-block;
  /* margin-right: 30px; */
}
@media screen and (max-width: 1300px) and (min-width: 800px) {
  .formCol {
    width: calc(100% / 2);
  }
}
@media screen and (max-width: 800px) {
  .formCol {
    width: 100%;
  }
}
.bottomBtn {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
.ivu-date-picker {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/process/MyQuery/components/SocialRelationship.vue